import { useEffect } from "react";
import { createUserManager } from "redux-oidc";
import { useGetTenantQuery, useRenewlicenseMutation } from "../../redux/api/BaseApi";
import { oAuthSettings } from "../Auth/AuthSettings";

const LicenseManager = () => {
  const { data: tenant } = useGetTenantQuery();

  const [
    renewLicense,
    //{ error }
  ] = useRenewlicenseMutation();


  useEffect(() => {

    //if (loop === null)
    //setLoop(
    let thisLoop = window.setInterval(async () => {
      try {
        await renewLicense(null).unwrap();
      } catch (err) {
        console.log('ooof', err);
        if ("status" in err) {
          if (err.status === 401) {
            //Token expired go to login page
            console.log('Token expired go to login page');
            let settings = oAuthSettings;
            if (tenant?.Authority)
              settings.authority = tenant?.Authority

            console.log('Redirecting to signin page', settings);
            let userManager = createUserManager(settings)
            await userManager.signinRedirect();
          }
          if (err.status === 403) {
            console.log('Auto logout', err.data);
            let settings = oAuthSettings;
            if (tenant?.Authority)
              settings.authority = tenant?.Authority

            let userManager = createUserManager(settings)
            //Kill the loop
            //setLoop(null);
            await userManager.signoutRedirect({
              extraQueryParams: { logoutMessage: err.data?.message },
            });
          }
        }
      }
    }, 30000);

    console.log('useEffect in LicenseManager.tsx', thisLoop);
    //);
    return () => {
      console.log('Cleanup Licensemanager', thisLoop)
      window.clearInterval(thisLoop);
    }
  }, []);
  return <></>;
};

export default LicenseManager;
